import { GzPolicyUiSettingsGridDataProvider } from '../../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/gridView/dataProvider/GzPolicyUiSettingsGridDataProvider';
import { Column, ColumnKeys } from './grid-config';
import { ContentControlApplicationRule } from '@nirvana/shared/dtos/types/policies/common';
import { SetFiltersRequest } from '../../../../../../../../grid/types/common';
import { convertRegexFilterToStartsWithFilter } from '../../../../../../../common/policyPanel/uiSettings/gridTemplate/utils/filters-converters';
import { sortByColumn } from './utils/sorters';

export class GzContentControlApplicationRulesGridDataProvider extends GzPolicyUiSettingsGridDataProvider<
  Column,
  ColumnKeys,
  ContentControlApplicationRule
> {
  sortByColumnMethod(
    a: ContentControlApplicationRule,
    b: ContentControlApplicationRule,
    sortColumnName: string,
    sortDirection: string
  ): number {
    return sortByColumn(a, b, sortColumnName, sortDirection);
  }

  async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    // convert regex to startsWith
    convertRegexFilterToStartsWithFilter(request, ColumnKeys.APP_PATH);
    return;
  }
}
